export default __webpack_public_path__ + "static/media/hostSpecialEvent.eb4385d7.jpg";